import { clientErrorTracker, getPagePath } from '@spotahome/soyuz/client';
import { deactivateUser } from '@spotahome/ui-library/src/tenant/mutations/users';
import getGraphqlClient from '@spotahome/tenant-common/src/graphql/client';

const disableUser = async () => {
  await deactivateUser(getGraphqlClient())();
};

const logoutUser = async () => {
  window.location.href = getPagePath('logout');
};

export const ACTIONS = {
  disableUser,
  logoutUser
};

export const applyActions = async actions => {
  if (!actions) {
    return;
  }

  const actionList = Array.isArray(actions) ? actions : [actions];

  for (let i = 0; i < actionList.length; i += 1) {
    const action = actionList[i];
    if (!Object.keys(ACTIONS).includes(action)) {
      // eslint-disable-next-line no-continue
      continue;
    }

    try {
      // eslint-disable-next-line no-await-in-loop
      await ACTIONS[action]();
    } catch (error) {
      clientErrorTracker.error({
        error,
        source: `ContanctUs-applyActions-${action}`
      });
    }
  }
};
